/* Davira Daily Planner — Shopify + Supabase. No third-party JS required. */
(function () {
  'use strict';
  var root = document.getElementById('davira-planner');
  if (!root) return;
  var config;
  try { config = JSON.parse(document.getElementById('dd-config').textContent); }
  catch (error) { root.textContent = 'Planner configuration is missing. Please check page.planner.liquid.'; return; }
  var base = config.supabaseUrl.replace(/\/$/, '');
  var storageKey = 'davira-planner:' + base;
  var soundPreferenceKey = storageKey + ':sound';
  var colors = ['butter', 'blue', 'sage', 'pink', 'lavender', 'peach', 'mint'];
  var state = {
    session: null, remember: false, role: null, tasks: [], alerts: [],
    modal: null, alertId: null, heard: {}, sound: false, audio: null, soundWanted: true,
    refreshing: null, syncing: false, syncAgain: false, generation: 0,
    recovery: false, lastColor: '', day: '', toastTimer: null, undoId: null,
    returnFocus: null, syncTime: '', lastError: '', ackBusy: false, revision: 0, noteTap: null
  };
  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(id) { return document.getElementById(id); }
  function text(id, value) { var node = el(id); if (node) node.textContent = value; }
  function today() {
    var p = new Intl.DateTimeFormat('en-GB', {
      timeZone: config.businessTimeZone || 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date());
    var values = {};
    p.forEach(function (part) { values[part.type] = part.value; });
    return values.year + '-' + values.month + '-' + values.day;
  }
  function dateLabel(date) {
    if (!date) return '';
    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC'
    }).format(new Date(date + 'T12:00:00Z'));
  }
  function nextDate(offset) {
    var d = new Date(today() + 'T12:00:00Z');
    d.setUTCDate(d.getUTCDate() + offset);
    return d.toISOString().slice(0, 10);
  }
  function brand() {
    var mark = '<div class="dd-brand-mark" aria-hidden="true"><svg viewBox="0 0 64 50" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 4H52L62 19 32 47 2 19Z M2 19H62 M12 4L21 19 32 47 43 19 52 4 M21 19L32 4 43 19 M32 4V47"/></svg></div>';
    if (/^https:\/\//i.test(config.logoUrl || '')) {
      mark = '<img class="dd-brand-logo" src="' + escapeHTML(config.logoUrl) + '" alt="' + escapeHTML(config.brandName) + '">';
    } else {
      mark += '<div class="dd-brand-name">DAVIRA DIAMONDS</div>';
    }
    return '<div class="dd-brand">' + mark + '<div class="dd-brand-subtitle">Daily planner</div></div>';
  }
  function button(action, label, extra, id) {
    return '<button type="button" class="dd-button ' + (extra || '') + '" data-action="' + action + '"' +
      (id ? ' data-id="' + escapeHTML(id) + '"' : '') + '>' + label + '</button>';
  }
  function flash(message, undoId) {
    clearTimeout(state.toastTimer);
    state.undoId = undoId || null;
    var host = el('dd-toast-host');
    if (!host) return;
    host.innerHTML = '<div class="dd-toast" role="status">' + escapeHTML(message) +
      (undoId ? '<button type="button" data-action="undo">Undo</button>' : '') + '</div>';
    state.toastTimer = setTimeout(function () { host.innerHTML = ''; state.undoId = null; }, 7000);
  }
  function errorText(error) {
    if (!navigator.onLine || error instanceof TypeError) return 'Connection unavailable. Check the internet and try again.';
    return error.message || 'Something went wrong. Please try again.';
  }
  async function request(path, method, body, token, headers) {
    var h = { apikey: config.supabasePublishableKey, 'Content-Type': 'application/json' };
    if (token) h.Authorization = 'Bearer ' + token;
    Object.keys(headers || {}).forEach(function (key) { h[key] = headers[key]; });
    // XMLHttpRequest works on older Android browsers and has a real timeout.
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(method || 'GET', base + path, true);
      xhr.timeout = 20000;
      Object.keys(h).forEach(function (key) { xhr.setRequestHeader(key, h[key]); });
      xhr.onload = function () {
        var data = null;
        try { data = xhr.responseText ? JSON.parse(xhr.responseText) : null; }
        catch (e) { data = null; }
        if (xhr.status >= 200 && xhr.status < 300) { resolve(data); return; }
        var err = new Error(data && (data.msg || data.message || data.error_description || data.error) || 'Request failed (' + xhr.status + ').');
        err.status = xhr.status;
        reject(err);
      };
      xhr.onerror = function () { reject(new TypeError('Network unavailable')); };
      xhr.ontimeout = function () { reject(new Error('Connection timed out. Check your internet and try again.')); };
      xhr.send(body === undefined ? null : JSON.stringify(body));
    });
  }
  function saveSession(session) {
    session.expires_at = session.expires_at || Math.floor(Date.now() / 1000) + Number(session.expires_in || 3600);
    state.session = session;
    try {
      localStorage.removeItem(storageKey);
      sessionStorage.removeItem(storageKey);
      (state.remember ? localStorage : sessionStorage).setItem(storageKey, JSON.stringify(session));
    } catch (error) { /* The current in-memory login can still be used. */ }
  }
  function resetSession() {
    cancelNoteTap();
    state.generation += 1;
    state.session = null; state.role = null; state.tasks = []; state.alerts = [];
    state.alertId = null; state.modal = null; state.recovery = false;
    try { localStorage.removeItem(storageKey); sessionStorage.removeItem(storageKey); } catch (error) {}
    loginView();
  }
  async function refreshSession() {
    if (state.refreshing) return state.refreshing;
    if (!state.session) throw new Error('Please sign in again.');
    var session = state.session, generation = state.generation;
    state.refreshing = (async function () {
      try {
        var result = await request('/auth/v1/token?grant_type=refresh_token', 'POST', { refresh_token: session.refresh_token });
        if (generation !== state.generation) throw new Error('Session changed.');
        saveSession(result);
      } catch (error) {
        if (generation === state.generation && (error.status === 400 || error.status === 401 || error.status === 403)) {
          resetSession(); text('dd-login-error', 'Your session ended. Please sign in again.');
        }
        throw error;
      }
    })();
    try { return await state.refreshing; } finally { state.refreshing = null; }
  }
  async function api(path, method, body, headers) {
    if (!state.session) throw new Error('Please sign in again.');
    if (state.session.expires_at * 1000 < Date.now() + 60000) await refreshSession();
    try { return await request(path, method, body, state.session.access_token, headers); }
    catch (error) {
      if (error.status !== 401) throw error;
      await refreshSession();
      return await request(path, method, body, state.session.access_token, headers);
    }
  }
  function loginView() {
    root.innerHTML = '<div class="dd-login"><div class="dd-login-card">' + brand() +
      '<h2>Welcome back</h2><p class="dd-muted">Sign in to your private daily board.</p>' +
      '<form id="dd-login-form"><label class="dd-field"><span class="dd-field-label">Email address</span><input class="dd-input" name="email" type="email" autocomplete="username" required></label>' +
      '<label class="dd-field"><span class="dd-field-label">Password</span><input class="dd-input" name="password" type="password" autocomplete="current-password" required></label>' +
      '<label class="dd-checkbox-label"><input name="remember" type="checkbox">Keep me signed in on this device</label>' +
      '<p id="dd-login-error" role="alert" class="dd-muted"></p><button class="dd-button dd-button--primary dd-full-width" type="submit">Sign in</button>' +
      '<button class="dd-text-button" type="button" data-action="forgot">Forgot password?</button></form></div></div><div id="dd-toast-host"></div>';
  }
  function boardView() {
    root.innerHTML = '<div class="dd-shell"><header class="dd-header">' + brand() +
      '<div><div class="dd-clocks"><div class="dd-clock"><div class="dd-clock-label">India</div><div class="dd-clock-time" id="dd-india-time"></div><div class="dd-clock-date" id="dd-india-date"></div></div>' +
      '<div class="dd-clock dd-clock--ny"><div class="dd-clock-label">New York</div><div class="dd-clock-time" id="dd-ny-time"></div><div class="dd-clock-date" id="dd-ny-date"></div></div></div>' +
      '<div id="dd-sync" class="dd-sync"><span class="dd-sync-dot"></span><span id="dd-sync-text">Connecting…</span></div></div></header>' +
      '<div id="dd-notice" class="dd-notice" hidden role="status"></div>' +
      '<main class="dd-board"><section class="dd-panel"><div class="dd-panel-heading"><h2>Pending</h2><span class="dd-count" id="dd-pending-count">0</span></div><div class="dd-notes" id="dd-pending"></div></section>' +
      '<section class="dd-panel dd-panel--today"><div class="dd-panel-heading"><h2 id="dd-today-title">Today</h2><span class="dd-count" id="dd-today-count">0</span></div><div class="dd-notes" id="dd-today"></div></section></main>' +
      '<footer class="dd-toolbar">' + button('new', '<span class="dd-button-icon">＋</span>New task', 'dd-button--primary') +
      button('all', 'All tasks') + button('completed', 'Completed') +
      (state.role === 'admin' ? button('send-alert', 'Send alert', 'dd-button--gold') : button('sound', 'Enable sound', 'dd-button--gold')) +
      '<span class="dd-toolbar-spacer"></span><span class="dd-user-label">' + (state.role === 'admin' ? 'MAIN ACCOUNT' : 'TV ACCOUNT') + '</span>' +
      button('settings', 'Settings', 'dd-button--quiet') + '</footer></div>' +
      '<div id="dd-modal-host"></div><div id="dd-alert-host"></div><div id="dd-toast-host"></div>';
    state.day = today(); updateClocks(); renderTasks(); updateSoundStatus();
  }
  function updateClocks() {
    if (!state.role || !el('dd-india-time')) return;
    var now = new Date();
    [['india', config.businessTimeZone || 'Asia/Kolkata'], ['ny', config.secondTimeZone || 'America/New_York']].forEach(function (pair) {
      text('dd-' + pair[0] + '-time', new Intl.DateTimeFormat('en-US', { timeZone: pair[1], hour: 'numeric', minute: '2-digit', hour12: true }).format(now));
      text('dd-' + pair[0] + '-date', new Intl.DateTimeFormat('en-GB', { timeZone: pair[1], day: 'numeric', month: 'short', year: 'numeric' }).format(now));
    });
    text('dd-today-title', 'Today · ' + dateLabel(today()).replace(/ \d{4}$/, ''));
    if (state.day !== today()) { state.day = today(); renderTasks(); }
  }
  function note(task) {
    var color = colors.indexOf(task.color) >= 0 ? task.color : 'butter';
    return '<article class="dd-note dd-note--' + color + '"><button type="button" class="dd-note-open" data-action="note" data-id="' + task.id + '" aria-label="View task: ' + escapeHTML(task.title) + '">' +
      (task.customer_name ? '<span class="dd-note-name">' + escapeHTML(task.customer_name) + '</span>' : '') +
      '<span class="dd-note-text">' + escapeHTML(task.title) + '</span></button><div class="dd-note-footer"><span class="dd-note-date ' + (task.due_date < today() ? 'dd-note-date--overdue' : '') + '">' +
      (task.due_date < today() ? 'Due ' + escapeHTML(dateLabel(task.due_date)) : 'Today') +
      '</span><button type="button" class="dd-complete" data-action="done" data-id="' + task.id + '" aria-label="Complete task: ' + escapeHTML(task.title) + '"><span class="dd-complete-circle"></span></button></div></article>';
  }
  function empty(title, detail) { return '<div class="dd-empty"><strong>' + title + '</strong>' + detail + '</div>'; }
  function replaceIfChanged(id, html) { var node = el(id); if (node && node.innerHTML !== html) node.innerHTML = html; }
  function renderTasks() {
    var day = today();
    var pending = state.tasks.filter(function (t) { return !t.completed_at && t.due_date < day; });
    var due = state.tasks.filter(function (t) { return !t.completed_at && t.due_date === day; });
    text('dd-pending-count', pending.length); text('dd-today-count', due.length);
    replaceIfChanged('dd-pending', pending.map(note).join('') || empty('All caught up', 'No overdue tasks.'));
    replaceIfChanged('dd-today', due.map(note).join('') || empty('A little breathing room', 'Add a task to plan your day.'));
    if (state.modal && (state.modal.type === 'all' || state.modal.type === 'completed')) renderList();
  }
  async function readPages(table, query) {
    var rows = [], offset = 0;
    while (true) {
      var page = await api('/rest/v1/' + table + '?' + query + '&limit=500&offset=' + offset);
      rows = rows.concat(page);
      if (page.length < 500) return rows;
      offset += 500;
    }
  }
  async function sync() {
    if (!state.role || state.recovery) return;
    if (state.syncing) { state.syncAgain = true; return; }
    state.syncing = true;
    var generation = state.generation, revision = state.revision;
    try {
      var results = await Promise.all([
        readPages('dd_tasks', 'select=*&order=due_date.asc,created_at.asc,id.asc'),
        readPages('dd_alerts', 'select=*&acknowledged_at=is.null&order=created_at.asc,id.asc')
      ]);
      if (generation !== state.generation || !state.role) return;
      if (revision !== state.revision) { state.syncAgain = true; return; }
      state.tasks = results[0]; state.alerts = results[1]; state.lastError = '';
      state.syncTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      renderTasks(); renderAlert();
      if (el('dd-sync')) el('dd-sync').className = 'dd-sync';
      text('dd-sync-text', 'Updated ' + state.syncTime);
      if (el('dd-notice')) el('dd-notice').hidden = true;
    } catch (error) {
      if (generation !== state.generation || !state.role) return;
      state.lastError = errorText(error);
      if (el('dd-sync')) el('dd-sync').className = 'dd-sync dd-sync--offline';
      text('dd-sync-text', 'Not syncing');
      var notice = el('dd-notice');
      if (notice) { notice.hidden = false; notice.textContent = state.lastError + ' Displayed tasks may be out of date; changes need a connection.'; }
    } finally {
      state.syncing = false;
      if (state.syncAgain) { state.syncAgain = false; setTimeout(sync, 100); }
    }
  }
  async function enterBoard() {
    var user = await api('/auth/v1/user');
    var roles = await api('/rest/v1/dd_members?select=role&user_id=eq.' + encodeURIComponent(user.id));
    if (!roles || roles.length !== 1 || ['admin', 'tv'].indexOf(roles[0].role) < 0) throw new Error('This account does not have planner access.');
    state.role = roles[0].role;
    boardView(); await sync();
  }
  function closeModal() {
    cancelNoteTap();
    var old = state.returnFocus;
    state.modal = null;
    if (el('dd-modal-host')) el('dd-modal-host').innerHTML = '';
    if (old && document.documentElement.contains(old)) old.focus();
  }
  function openModal(type, title, content, wide) {
    cancelNoteTap();
    if (!state.modal) state.returnFocus = document.activeElement;
    state.modal = { type: type };
    el('dd-modal-host').innerHTML = '<div class="dd-overlay"><section class="dd-modal ' + (wide ? 'dd-modal--wide' : '') + '" role="dialog" aria-modal="true" aria-labelledby="dd-modal-title"><div class="dd-modal-heading"><h2 id="dd-modal-title">' + title +
      '</h2><button type="button" class="dd-icon-button" data-action="close" aria-label="Close">✕</button></div>' + content + '<p id="dd-modal-error" role="alert" class="dd-muted"></p></section></div>';
    var first = el('dd-modal-host').querySelector('input, textarea, select, button');
    if (first) first.focus();
  }
  function cancelNoteTap() {
    if (state.noteTap) clearTimeout(state.noteTap.timer);
    state.noteTap = null;
  }
  function previewNote(id) {
    var task = state.tasks.find(function (t) { return t.id === id; });
    if (!task) { flash('Task is no longer available. Refresh and try again.'); return; }
    var color = colors.indexOf(task.color) >= 0 ? task.color : 'butter';
    openModal('preview', 'Your note', '<div class="dd-note-preview dd-note--' + color + '" data-action="note" data-id="' + escapeHTML(id) + '" tabindex="0" role="button" aria-label="Double tap to edit this note. Keyboard: F2." aria-describedby="dd-preview-hint">' +
      '<div class="dd-preview-date">' + (task.completed_at ? 'Completed · ' : task.due_date < today() ? 'Pending · ' : '') + 'Due ' + escapeHTML(dateLabel(task.due_date)) + '</div>' +
      (task.customer_name ? '<h3 class="dd-preview-name">' + escapeHTML(task.customer_name) + '</h3>' : '') +
      '<div class="dd-preview-text">' + escapeHTML(task.title) + '</div></div>' +
      '<p id="dd-preview-hint" class="dd-preview-hint">Double tap / double click the note to edit · Keyboard: F2</p>', true);
    state.modal.taskId = id;
  }
  function activateNote(id) {
    if (state.alertId) return;
    var pending = state.noteTap;
    if (pending && pending.id === id && Date.now() - pending.time <= 400) {
      cancelNoteTap(); taskForm(id); return;
    }
    cancelNoteTap();
    state.noteTap = { id: id, time: Date.now(), timer: setTimeout(function () {
      state.noteTap = null;
      if (state.alertId || !state.role) return;
      if (state.modal && state.modal.type === 'preview' && state.modal.taskId === id) return;
      previewNote(id);
    }, 400) };
  }
  function taskForm(id) {
    var task = id ? state.tasks.find(function (t) { return t.id === id; }) : null;
    if (id && !task) { flash('Task is no longer available. Refresh and try again.'); return; }
    var options = colors.filter(function (c) { return c !== state.lastColor; });
    var color = task ? task.color : options[Math.floor(Math.random() * options.length)];
    state.lastColor = color;
    openModal('task', task ? 'Edit task' : 'New task', '<form id="dd-task-form">' +
      '<label class="dd-field"><span class="dd-field-label">Customer / name (optional)</span><input class="dd-input" name="customer_name" maxlength="120" value="' + escapeHTML(task && task.customer_name) + '"></label>' +
      '<label class="dd-field"><span class="dd-field-label">What needs to be done?</span><textarea class="dd-input" name="title" required maxlength="1000">' + escapeHTML(task && task.title) + '</textarea></label>' +
      '<label class="dd-field"><span class="dd-field-label">Date</span><input class="dd-input" type="date" name="due_date" required value="' + (task ? task.due_date : today()) + '"></label>' +
      '<div class="dd-date-shortcuts">' + button('date-today', 'Today') + button('date-tomorrow', 'Tomorrow') + '</div>' +
      '<span class="dd-field-label">Note colour</span><div class="dd-color-options">' + colors.map(function (c) {
        return '<button type="button" class="dd-swatch dd-note--' + c + '" data-action="color" data-id="' + c + '" aria-label="' + c + '" aria-pressed="' + (c === color) + '"></button>';
      }).join('') + '</div><input type="hidden" name="color" value="' + color + '">' +
      '<div class="dd-modal-actions">' + button('close', 'Cancel') + '<button class="dd-button dd-button--primary" type="submit">Save task</button></div></form>');
    state.modal.taskId = task ? task.id : null;
    state.modal.version = task ? task.updated_at : null;
    var name = el('dd-task-form').elements.customer_name; name.focus();
  }
  function listView(type) {
    openModal(type, type === 'all' ? 'All upcoming & open tasks' : 'Completed tasks', '<div id="dd-list"></div>', true);
    renderList();
  }
  function renderList() {
    if (!el('dd-list')) return;
    var completed = state.modal.type === 'completed';
    var list = state.tasks.filter(function (t) { return completed ? !!t.completed_at : !t.completed_at; });
    if (completed) list.sort(function (a, b) { return b.completed_at.localeCompare(a.completed_at); });
    replaceIfChanged('dd-list', list.map(function (t) {
      return '<div class="dd-list-row"><div class="dd-list-content"><div class="dd-list-title">' + escapeHTML(t.customer_name || 'Task') + '</div><div>' + escapeHTML(t.title) + '</div><div class="dd-list-meta">Due ' + escapeHTML(dateLabel(t.due_date)) + '</div></div><div class="dd-list-actions">' +
        (completed ? button('reopen', 'Reopen', '', t.id) : button('edit', 'Edit', '', t.id) + button('done', 'Done', '', t.id)) + '</div></div>';
    }).join('') || empty(completed ? 'No completed tasks yet' : 'No open tasks', ''));
  }
  async function changeTask(id, changes, version) {
    var query = '/rest/v1/dd_tasks?id=eq.' + encodeURIComponent(id);
    if (version) query += '&updated_at=eq.' + encodeURIComponent(version);
    var rows = await api(query, 'PATCH', changes, { Prefer: 'return=representation' });
    if (!rows || !rows.length) throw new Error('This task changed on another device. Close this form, refresh, and try again.');
    state.revision += 1;
    state.tasks = state.tasks.map(function (t) { return t.id === id ? rows[0] : t; });
    renderTasks(); return rows[0];
  }
  function sendAlertForm() {
    if (state.role !== 'admin') return;
    openModal('send-alert', 'Message to the TV', '<form id="dd-alert-form"><label class="dd-field"><span class="dd-field-label">Your message</span><textarea class="dd-input" name="message" required maxlength="1000" placeholder="Diana nu CAD have mokli aapjo."></textarea></label><p class="dd-muted">Stays on the TV until OK is pressed. Sound plays once for two seconds when enabled. Messages are queued in order.</p><div class="dd-modal-actions">' + button('close', 'Cancel') + '<button type="submit" class="dd-button dd-button--primary">Send alert</button></div></form>');
    el('dd-alert-form').elements.message.focus();
  }
  function updateSoundStatus() {
    state.sound = !!(state.audio && state.audio.state === 'running');
    var toolbar = root.querySelector('.dd-toolbar [data-action="sound"]');
    if (toolbar) toolbar.hidden = state.sound;
    var alertSound = el('dd-alert-sound');
    if (alertSound) alertSound.hidden = state.sound;
    var status = el('dd-sound-status');
    if (status) status.textContent = state.sound ? 'Alert sound is on · saved for this device.' : 'Alert sound is on by default. Touch this page once to allow audio.';
    var test = el('dd-modal-host') && el('dd-modal-host').querySelector('[data-action="sound"]');
    if (test) test.textContent = state.sound ? 'Test sound' : 'Enable sound';
    playPendingAlert();
  }
  async function activateSound() {
    var Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio) throw new Error('This browser does not support alert sound. Visual alerts will still work.');
    state.soundWanted = true;
    try { localStorage.setItem(soundPreferenceKey, 'on'); } catch (error) {}
    if (!state.audio || state.audio.state === 'closed') {
      state.audio = new Audio();
      state.audio.onstatechange = updateSoundStatus;
    }
    updateSoundStatus();
    if (state.audio.state !== 'running') await state.audio.resume();
    updateSoundStatus();
    if (state.audio.state !== 'running') throw new Error('Touch Enable sound again to allow audio.');
  }
  function autoSound() {
    if (!state.soundWanted) return;
    if (state.audio && state.audio.state === 'running') { updateSoundStatus(); return; }
    activateSound().catch(function () { updateSoundStatus(); });
  }
  async function enableSound() {
    await activateSound();
    chime(); flash('Alert sound is on and saved for this device.');
  }
  function playPendingAlert() {
    if (state.role !== 'tv' || !state.alertId || !state.sound || state.heard[state.alertId]) return;
    if (chime()) state.heard[state.alertId] = true;
  }
  function chime() {
    if (!state.sound || !state.audio || state.audio.state !== 'running') return;
    var ctx = state.audio, now = ctx.currentTime;
    if (state.soundUntil && now < state.soundUntil) return;
    state.soundUntil = now + 2;
    // Six distinct two-tone pulses, with headroom and smooth edges for TV speakers.
    [880, 1174.66, 880, 1174.66, 880, 1174.66].forEach(function (frequency, i) {
      var osc = ctx.createOscillator(), gain = ctx.createGain(), start = now + i * 0.33;
      osc.type = 'triangle'; osc.frequency.value = frequency;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.65, start + 0.012);
      gain.gain.setValueAtTime(0.65, start + 0.19);
      gain.gain.linearRampToValueAtTime(0, start + 0.28);
      osc.connect(gain); gain.connect(ctx.destination);
      osc.start(start); osc.stop(start + 0.29);
      osc.onended = function () { osc.disconnect(); gain.disconnect(); };
    });
    return true;
  }
  function renderAlert() {
    if (state.role !== 'tv' || !el('dd-alert-host')) return;
    var alert = state.alerts[0];
    if (!alert) {
      state.alertId = null; el('dd-alert-host').innerHTML = ''; return;
    }
    if (state.alertId === alert.id) { updateSoundStatus(); return; }
    cancelNoteTap();
    state.alertId = alert.id;
    el('dd-alert-host').innerHTML = '<div class="dd-overlay dd-alert-overlay"><section class="dd-alert-panel" role="alertdialog" aria-modal="true" aria-labelledby="dd-alert-message">' + brand() +
      '<div class="dd-alert-label">Message from Admin</div><div id="dd-alert-message" class="dd-alert-message">' + escapeHTML(alert.message) + '</div>' +
      button('ack', '✓ OK, સમજાયું', 'dd-button--primary', alert.id) +
      '<div class="dd-alert-meta">' + (state.alerts.length > 1 ? state.alerts.length + ' messages waiting · ' : '') +
      'This message stays until you acknowledge it.</div><p id="dd-ack-error" role="alert"></p>' +
      '<div id="dd-alert-sound" class="dd-alert-meta">' + button('sound', 'Enable sound', 'dd-button--quiet') + '</div></section></div>';
    updateSoundStatus();
    var ok = el('dd-alert-host').querySelector('[data-action="ack"]'); if (ok) ok.focus();
  }
  function settings() {
    openModal('settings', 'Planner settings', '<p class="dd-muted">India controls Today and Pending. New York adjusts automatically for daylight saving.</p>' +
      '<p>Account: <strong>' + (state.role === 'admin' ? 'Main / Admin' : 'TV') + '</strong></p>' +
      '<p class="dd-muted">Tasks and messages refresh every 5 seconds while this page is active. Reconnecting also checks for unread alerts.</p>' +
      (state.role === 'admin' ? '<p id="dd-alert-summary" class="dd-muted">' + state.alerts.length + ' TV alerts awaiting OK.</p>' : '') +
      '<p id="dd-sound-status" class="dd-muted" role="status"></p>' +
      '<div class="dd-modal-actions">' + button('refresh', 'Refresh now') + button('sound', 'Test / enable sound') + button('fullscreen', 'Full screen') + button('logout', 'Log out', 'dd-button--primary') + '</div>');
    updateSoundStatus();
  }
  async function acknowledge(id) {
    if (state.ackBusy) return;
    state.ackBusy = true;
    try {
      await api('/rest/v1/rpc/dd_acknowledge_alert', 'POST', { p_alert_id: id });
      state.revision += 1;
      state.alerts = state.alerts.filter(function (a) { return a.id !== id; });
      state.alertId = null; renderAlert(); sync();
    } catch (error) { text('dd-ack-error', errorText(error) + ' The alert has not been dismissed.'); }
    finally { state.ackBusy = false; }
  }
  async function logout() {
    if (!window.confirm('Log out of this planner on this device?')) return;
    try { await api('/auth/v1/logout?scope=local', 'POST'); }
    catch (error) { /* Clear this device even when the network is offline. */ }
    resetSession();
  }
  async function forgotPassword() {
    var form = el('dd-login-form');
    var email = form.elements.email.value.trim();
    if (!email || !form.elements.email.checkValidity()) { text('dd-login-error', 'Enter your email address first, then press Forgot password.'); form.elements.email.focus(); return; }
    var redirect = location.origin + '/pages/planner';
    await request('/auth/v1/recover?redirect_to=' + encodeURIComponent(redirect), 'POST', { email: email });
    text('dd-login-error', 'If this email has an account, check its inbox for the password reset link.');
  }
  function recoveryView() {
    root.innerHTML = '<div class="dd-login"><div class="dd-login-card">' + brand() + '<h2>Choose a new password</h2><form id="dd-recovery-form"><label class="dd-field"><span class="dd-field-label">New password</span><input class="dd-input" type="password" name="password" minlength="12" autocomplete="new-password" required></label><label class="dd-field"><span class="dd-field-label">Confirm password</span><input class="dd-input" type="password" name="confirm" minlength="12" autocomplete="new-password" required></label><p id="dd-login-error" role="alert"></p><button type="submit" class="dd-button dd-button--primary dd-full-width">Save password</button></form></div></div><div id="dd-toast-host"></div>';
  }
  root.addEventListener('submit', async function (event) {
    event.preventDefault();
    var form = event.target;
    if (!form.checkValidity()) { form.reportValidity(); return; }
    var submit = form.querySelector('[type="submit"]');
    if (submit && submit.disabled) return;
    if (submit) submit.disabled = true;
    try {
      if (form.id === 'dd-login-form') {
        text('dd-login-error', 'Signing in…');
        state.remember = form.elements.remember.checked;
        var session = await request('/auth/v1/token?grant_type=password', 'POST', { email: form.elements.email.value.trim(), password: form.elements.password.value });
        state.generation += 1; saveSession(session); await enterBoard();
      } else if (form.id === 'dd-task-form') {
        var data = { customer_name: form.elements.customer_name.value.trim(), title: form.elements.title.value.trim(), due_date: form.elements.due_date.value, color: form.elements.color.value };
        if (!data.title) throw new Error('Please describe the task.');
        if (state.modal.taskId) await changeTask(state.modal.taskId, data, state.modal.version);
        else { await api('/rest/v1/dd_tasks', 'POST', data, { Prefer: 'return=representation' }); state.revision += 1; }
        closeModal(); flash('Task saved.'); await sync();
      } else if (form.id === 'dd-alert-form') {
        var message = form.elements.message.value.trim();
        if (!message) throw new Error('Please enter an alert message.');
        await api('/rest/v1/dd_alerts', 'POST', { message: message }, { Prefer: 'return=representation' });
        state.revision += 1;
        closeModal(); flash('Alert saved for the TV. It will appear when the TV is connected.'); await sync();
      } else if (form.id === 'dd-recovery-form') {
        if (form.elements.password.value !== form.elements.confirm.value) throw new Error('The passwords do not match.');
        await api('/auth/v1/user', 'PUT', { password: form.elements.password.value });
        state.recovery = false; await enterBoard(); flash('Password updated.');
      }
    } catch (error) {
      if (form.id === 'dd-login-form' && state.session) {
        resetSession();
      }
      var errorId = form.id === 'dd-login-form' || form.id === 'dd-recovery-form' ? 'dd-login-error' : 'dd-modal-error';
      text(errorId, errorText(error));
    } finally { if (submit) submit.disabled = false; }
  });
  root.addEventListener('click', async function (event) {
    var target = event.target.closest('[data-action]');
    if (!target || !root.contains(target) || target.disabled) return;
    var action = target.getAttribute('data-action'), id = target.getAttribute('data-id');
    if (action === 'note') { activateNote(id); return; }
    cancelNoteTap();
    target.disabled = true;
    try {
      if (action === 'new') taskForm();
      else if (action === 'edit') taskForm(id);
      else if (action === 'close') closeModal();
      else if (action === 'all' || action === 'completed') listView(action);
      else if (action === 'send-alert') sendAlertForm();
      else if (action === 'settings') settings();
      else if (action === 'sound') await enableSound();
      else if (action === 'ack') await acknowledge(id);
      else if (action === 'logout') await logout();
      else if (action === 'forgot') await forgotPassword();
      else if (action === 'refresh') { await sync(); if (state.lastError) throw new Error(state.lastError); flash('Board updated.'); }
      else if (action === 'fullscreen') {
        var fn = document.documentElement.requestFullscreen || document.documentElement.webkitRequestFullscreen;
        if (fn) { await fn.call(document.documentElement); closeModal(); }
        else throw new Error('Use the browser full-screen option on this device.');
      } else if (action === 'done' || action === 'reopen' || action === 'undo') {
        if (action === 'undo') id = state.undoId;
        if (!id) return;
        var task = state.tasks.find(function (t) { return t.id === id; });
        if (!task) throw new Error('Task not found. Refresh and try again.');
        await changeTask(id, { completed_at: action === 'done' ? new Date().toISOString() : null }, task.updated_at);
        flash(action === 'done' ? 'Task completed.' : 'Task reopened.', action === 'done' ? id : null); sync();
      } else if (action === 'date-today' || action === 'date-tomorrow') {
        el('dd-task-form').elements.due_date.value = nextDate(action === 'date-tomorrow' ? 1 : 0);
      } else if (action === 'color') {
        el('dd-task-form').elements.color.value = id;
        Array.prototype.forEach.call(root.querySelectorAll('.dd-swatch'), function (swatch) { swatch.setAttribute('aria-pressed', String(swatch.getAttribute('data-id') === id)); });
      }
    } catch (error) {
      if (el('dd-modal-error') && state.modal) text('dd-modal-error', errorText(error));
      else if (el('dd-login-error')) text('dd-login-error', errorText(error));
      else flash(errorText(error));
    } finally { target.disabled = false; }
  });
  root.addEventListener('dblclick', function (event) {
    var target = event.target.closest('[data-action="note"]');
    if (!target || !root.contains(target) || state.alertId) return;
    event.preventDefault(); cancelNoteTap();
    var id = target.getAttribute('data-id');
    if (!state.modal || state.modal.type !== 'task' || state.modal.taskId !== id) taskForm(id);
  });
  root.addEventListener('keydown', function (event) {
    var noteTarget = event.target.closest('[data-action="note"]');
    if (noteTarget && !state.alertId) {
      if (event.key === 'F2') { event.preventDefault(); cancelNoteTap(); taskForm(noteTarget.getAttribute('data-id')); return; }
      if (noteTarget.classList.contains('dd-note-preview') && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault(); return;
      }
    }
    var host = state.alertId ? el('dd-alert-host') : state.modal ? el('dd-modal-host') : null;
    if (!host) return;
    if (event.key === 'Escape') { if (!state.alertId) closeModal(); event.preventDefault(); }
    if (event.key !== 'Tab') return;
    var nodes = Array.prototype.filter.call(host.querySelectorAll('button, input, textarea, select, a[href], [tabindex="0"]'), function (n) { return !n.disabled && n.type !== 'hidden' && n.offsetParent !== null; });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || !host.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !host.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
  window.addEventListener('online', function () { sync(); });
  window.addEventListener('storage', function (event) {
    if (event.key !== storageKey || !state.remember) return;
    if (!event.newValue) return; // A session update briefly removes the old value.
    try {
      var incoming = JSON.parse(event.newValue);
      if (state.session && incoming.user && state.session.user && incoming.user.id !== state.session.user.id) { location.reload(); return; }
      state.session = incoming;
    } catch (error) {}
  });
  // Browser autoplay permission is unlocked by a normal login, tap or key press.
  ['touchend', 'click', 'keydown'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) { if (event.isTrusted) autoSound(); }, true);
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { autoSound(); updateClocks(); sync(); } });
  setInterval(updateClocks, 1000);
  setInterval(function () { if (!document.hidden) sync(); }, 5000);
  async function start() {
    try { state.soundWanted = localStorage.getItem(soundPreferenceKey) !== 'off'; } catch (error) {}
    autoSound();
    try {
      var hash = new URLSearchParams(location.hash.slice(1));
      if (hash.has('error_description')) {
        var message = hash.get('error_description'); history.replaceState(null, '', location.pathname + location.search);
        loginView(); text('dd-login-error', message); return;
      }
      if (hash.get('type') === 'recovery' && hash.has('access_token') && hash.has('refresh_token')) {
        state.remember = false;
        saveSession({ access_token: hash.get('access_token'), refresh_token: hash.get('refresh_token'), expires_in: Number(hash.get('expires_in') || 3600) });
        history.replaceState(null, '', location.pathname + location.search);
        state.recovery = true; recoveryView(); return;
      }
      try {
        var remembered = localStorage.getItem(storageKey);
        state.remember = !!remembered;
        var stored = remembered || sessionStorage.getItem(storageKey);
        if (stored) state.session = JSON.parse(stored);
      } catch (error) { state.session = null; }
      if (state.session && state.session.access_token && state.session.refresh_token) await enterBoard();
      else loginView();
    } catch (error) {
      loginView(); text('dd-login-error', errorText(error));
    }
  }
  start();
})();
